// Activity types in range 1000-1099 are APQ
export enum ActivityType {
  ApqMessageSentOfqual = 1000,
  ApqMessageSentAO = 1001,
  ApqClosed = 1002,
  ApqReOpened = 1003,
  ApqAssigned = 1004
}
